import { createSelector } from 'reselect';

const EMPTY_ENTITIES = {};
const EMPTY_IDS = [];

export const getCities = state => state.currency?.citiesList;
export const getCitiesEntities = createSelector(
  getCities,
  cities => cities?.entities || EMPTY_ENTITIES
);
export const getCitiesIds = createSelector(
  getCities,
  cities => cities?.ids || EMPTY_IDS
);
export const getCitiesItems = createSelector(
  getCitiesEntities,
  getCitiesIds,
  (entities, ids) => {
    return ids.map(value => entities[value]);
  }
);

export const getSortedCitiesItems = createSelector(getCitiesItems, cities =>
  [...cities].sort((a, b) => a.label.localeCompare(b.label))
);

export const makeCurrentCity = () =>
  createSelector(
    getCitiesItems,
    (state, props) => props.city,
    (cities, key) => {
      if (key) {
        return cities.find(item => item.value === key) || null;
      }
      return null;
    }
  );

export const getCurrentCity = makeCurrentCity();
